import { AxiosInstance } from 'axios'

import { iamDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiLoginTwoFactorAuthAppPostRequest,
  DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest,
  DefaultApiLoginTwoFactorAuthSmsPostRequest,
  DefaultApiSaveSamlRedirectUrlRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/iam'

export const loginTwoFactorAuthAppPost = async (
  instance: AxiosInstance,
  params: DefaultApiLoginTwoFactorAuthAppPostRequest
) => {
  return await iamDefaultApiFactory(instance).loginTwoFactorAuthAppPost(params)
}

export const loginTwoFactorAuthSmsPost = async (
  instance: AxiosInstance,
  params: DefaultApiLoginTwoFactorAuthSmsPostRequest
) => {
  return await iamDefaultApiFactory(instance).loginTwoFactorAuthSmsPost(params)
}

export const loginWithTwoFactorAuthRecoveryCode = async (
  instance: AxiosInstance,
  params: DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest
) => {
  return await iamDefaultApiFactory(
    instance
  ).loginTwoFactorAuthRecoveryCodePost(params)
}

export const saveSamlRedirectUrl = async (
  instance: AxiosInstance,
  params: DefaultApiSaveSamlRedirectUrlRequest
) => {
  return await iamDefaultApiFactory(instance).saveSamlRedirectUrl(params)
}

// Do Not Remove this line ===@import api client===
